define((require) => {
    "use strict";

    const ActionPropertiesView          = require("ui/experience/action/ActionPropertiesView");
    const AnimationPropertiesView       = require("ui/experience/widgets/animations/AnimationPropertiesView");
    const CharacterPropertiesView       = require("ui/experience/widgets/CharacterPropertiesView");
    const ImprovedView                  = require("editor/zbone/ImprovedView");
    const SizeAndPositionPropertiesView = require("ui/experience/widgets/SizeAndPositionPropertiesView");
    const template                      = require("ui/experience/widgets/htmlWidget/HtmlWidgetPropertiesView.tpl");

    /**
     * The properties view for a html widget.
     *
     * @class HtmlWidgetPropertiesView
     * @constructor
     *
     * @cfg {HtmlWidgetModel} model The model for the html widget being edited.
     */
    return ImprovedView.extend({

        template,

        regions: {
            sizeAndPositionProperties: ".size-and-position-properties",
            analyticsProperties: ".analytics-properties",
            animationProperties: ".animation-properties",
            actionProperties: ".action-properties"
        },

        onRender() {
            this.__super();

            this.sizeAndPositionProperties.show(new SizeAndPositionPropertiesView({
                model: this.model,
                widgetView: this.options.widgetView,
                hideRotation: true
            }));
            this.analyticsProperties.show(this._setAnalyticsLabel({model: this.model}));
            this.animationProperties.show(new AnimationPropertiesView({model: this.model, widgetView: this.options.widgetView}));
            this.actionProperties.show(new ActionPropertiesView({model: this.model}));
        }
    }, {
        EXPAND_PROPERTY: CharacterPropertiesView.EXPAND_PROPERTY
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/htmlWidget/HtmlWidgetPropertiesView.js